import { combineReducers } from "redux";
import user from "./Reducers/user";
import applications from "./Reducers/applications";
import authentication from "./Reducers/authentication";
import channel from "./Reducers/channel";
import search from "./Reducers/search";
import contacts from "./Reducers/contacts";
import documentation from "./Reducers/documentation";
import payments from "./Reducers/payments";
import invoices from "./Reducers/invoices";
import sandBoxAuthentication from "./Reducers/sandBoxAuthentication";
import sandBoxApplications from "./Reducers/sandBoxApplications";
import sandBoxContacts from "./Reducers/sandBoxContacts";

const rootReducer = combineReducers({
    user,
    authentication,
    channel,
    search,
    contacts,
    applications,
    documentation,
    payments,
    invoices,
    sandBoxAuthentication,
    sandBoxApplications,
    sandBoxContacts
});

export default rootReducer;
